import { useEffect, useState } from "react";

const read = () => localStorage.getItem("dp-theme") === "dark";

export function useTheme() {
  const [dark, setDark] = useState(read);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("dp-theme", dark ? "dark" : "light");
  }, [dark]);
  return { dark, toggle: () => setDark((d) => !d) };
}
